var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quick-alert py-2 px-3 font-size-small d-flex align-items-center",class:_vm.cssClass},[_c('span',[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }